import { ref } from '../../common/ref';
export class Plugin {
    constructor() {
        this._renderer = ref();
    }
    plug(renderer) {
        this._renderer.resolve(renderer);
    }
    renderer() {
        return this._renderer.$;
    }
}
Plugin.PriorityMax = 1;
Plugin.PriorityFallback = 0;
export function isRendererWithPlugins(renderer) {
    return !!renderer.plugins && Array.isArray(renderer.plugins);
}
//# sourceMappingURL=plugin.js.map